<template lang="pug">
.send-request-reply-message.pt-1.pr-2.pb-1.pl-2
  .datetime.mb-2 {{ _datetime }}
  .message-text.pre-line {{ _messageText }}
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

import { OtherOfficeAcceptanceRequestRepliesGetModel } from "@/commons/services/OtherOfficeAcceptanceRequestReplies";

/**
 * ### 返信状況タブの施設情報コンポーネント
 */
@Component
export default class SendRequestReplyMessage extends Vue {
  /** 親コンポーネントでv-modelで指定した値 */
  @Prop()
  value!: OtherOfficeAcceptanceRequestRepliesGetModel;

  get _value(): OtherOfficeAcceptanceRequestRepliesGetModel {
    return this.value;
  }

  get _datetime(): string {
    if (!this.value.datetime) {
      return "";
    }
    return this.$dateUtil.convertNumberToString(Number(this.value.datetime), "yyyy/mm/dd hh:MM");
  }

  get _messageText(): string {
    return this.value.messageText ? this.value.messageText : "";
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_colors.scss";

.send-request-reply-message {
  border: 1px solid $border-lightgray;
  border-radius: 0.5rem;

  .datetime {
    font-size: 14px;
    color: $font-disable-font-color;
  }
}
</style>
